<script setup lang="ts">
import DashboardPlugin from "@uppy/dashboard";
// import { shallowEqualObjects } from "shallow-equal";
const props = defineProps({
  uppy: {
    type: Object,
    required: true,
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  plugins: {
    type: Array,
    default: () => [],
  },
  open: {
    type: Boolean,
    required: true,
  },
});
const plugin = ref({});
const container = ref(null);
const { plugins, open, data, uppy } = toRefs(props);
function installPlugin() {
  const options = {
    id: "vue:DashboardModal",
    plugins: plugins.value,
    ...data.value,
    target: container.value,
  };
  uppy.value.use(DashboardPlugin, options);
  plugin.value = uppy.value.getPlugin(options.id);
  if (open.value) {
    plugin.value.openModal();
  }
}
function uninstallPlugin(uppy) {
  uppy.removePlugin(plugin.value);
}
onMounted(() => {
  installPlugin();
});
onUnmounted(()=>{
   uninstallPlugin(uppy.value);
})
onBeforeUnmount(() => {
  uninstallPlugin(uppy.value);
});
watch(uppy.value, (current, old) => {
  if (old !== current) {
    console.log('uppy')
    uninstallPlugin(old);
    installPlugin();
  }
});
watch(open, (current, old) => {
  if (current && !old) {
    plugin.value.openModal();
  }
  if (!current && old) {
    plugin.value.closeModal();
  }
});
watch(props, (current, old) => {
  // plugin.value.setOptions({ ...current });
  // if (!shallowEqualObjects(current, old)) {
    // plugin.value.setOptions({ ...current });
  // }
});
</script>
<template>
  <div ref="container"></div>
</template>
